module.exports = __webpack_public_path__ + "static/media/Penerbit_BACA_PNG.2e9719a5.png";